var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-counter-item",class:[`tone-${_vm.tone}`, { active: _vm.active }],on:{"click":_vm.onActive}},[_c('span',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"item-count"},[_vm._v(_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }